<template>
    <section>
      <div class="container">
        <section v-if="recent_chapters.length > 0" class="mt-5">
          <div class="mb-5 text-center text-md-start">
            <h1 class="headline_3">Recent Chapters</h1>
            <a class="text-center text-link" @click="clearAllChapters">Clear all</a>
          </div>
          <Carousel v-bind="settings" :breakpoints="breakpoints">
            <slide v-for="item in recent_chapters" :key="item" class="p-2">

              <router-link :to="'/chapter/details/' + item.chapter_number" class="text-decoration-none card_page_wrapper">
                <div class="card cover_card text-center h-100">
                  <div class="card-body py-5">
                    <div class="card-number">{{ item.chapter_number }}</div>

                    <h1>{{item.name}}</h1>
                    <p>{{ item.translation }}</p>
                    <h6>{{ item.meaning.en }}</h6>
                    <p>Sloks : {{ item.verses_count }}</p>
                  </div>
                </div>
              </router-link>
            </slide>
            
          </Carousel>
        </section>
      </div>
    </section>
  </template>
  
  <script>
  import swal from 'sweetalert';

  
  // for slider
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide } from 'vue3-carousel'
  // for slider
  
  export default {
      name: 'RecentChapter',
      data() {
        return {
          recent_chapters:this.$store.getters.getRChapters,
  
          // carousel settings
          settings: {
            itemsToShow: 1,
            snapAlign: 'center',
            gap: 10
          },
          // breakpoints are mobile first
          // any settings not specified will fallback to the carousel settings
          breakpoints: {
            // 700px and up
            700: {
              itemsToShow: 2,
              snapAlign: 'center',
            },
            // 1024 and up
            1024: {
              itemsToShow: 4,
              snapAlign: 'start',
            },
          },
        };
      },
      components: {
        Carousel,
        Slide,
      },
      mounted() {
      },
      methods: {
        clearAllChapters()
        {
          this.$store.commit('CLEAR_R_CHAPTERS');
          
  
          swal({
            title: "Success",
            text: "All recently chapter's history is cleard successfully",
            icon: "success",
          }).then(function() {
            location.reload();
          });
        }
      }
  }
  </script>
  
  <style scoped>
   @media only screen and (max-width: 600px) {
    .vh-100
    {
      height: auto !important;
      padding: 50px 0 !important;
    }
   }
  
  </style>
  